module.exports = __webpack_public_path__ + "static/media/logo_animalcrossing_en-2x.8a45b93b.png";